import { createSlice } from '@reduxjs/toolkit';

export const appSlice = createSlice({
    name: 'app',
    initialState: {
        hideUpcomingEvents: false,
        hideRecentEvents: false,
        notesOpenId: null,
        contentDialogMode: false,
        showingBackgroundSlug: null,
    },
    reducers: {
        setNotesOpenId: (state, action) => {
            state.notesOpenId = action.payload;
        },
        setHideUpcomingEvents: (state, action) => {
            state.hideUpcomingEvents = action.payload;
        },
        setHideRecentEvents: (state, action) => {
            state.hideRecentEvents = action.payload;
        },
        setContentDialogMode: (state, action) => {
            state.contentDialogMode = action.payload;
        },
        setShowingBackgroundSlug: (state, action) => {
            if (state.showingBackgroundSlug && !action.payload) {
                state.contentDialogMode = false;
            } else if(!state.showingBackgroundSlug && action.payload) {
                state.contentDialogMode = true;
            }
            state.showingBackgroundSlug = action.payload;
        },
    },
});

export const {
    setHideUpcomingEvents,
    setHideRecentEvents,
    setNotesOpenId,
    setContentDialogMode,
    setShowingBackgroundSlug,
} = appSlice.actions;

export const getNotesOpenId = (state) => state.app.notesOpenId;
export const getHideUpcomingEvents = (state) => state.app.hideUpcomingEvents;
export const getHideRecentEvents = (state) => state.app.hideRecentEvents;
export const getContentDialogMode = (state) => state.app.contentDialogMode || !!(state.app.showingBackgroundSlug);
export const getShowingBackgroundSlug = (state) => state.app.showingBackgroundSlug;

export default appSlice.reducer;
